export default __webpack_public_path__ + "static/media/donation4.f588b461.jpg";